import { Radio } from "antd";
import { GenericRadioProps, RadioGroupProps } from "./types";

function AntRadio<T>(props: GenericRadioProps<T>) {
  return <Radio {...props} />;
}

function AntRadioGroup(props: RadioGroupProps) {
  return <Radio.Group {...props} />;
}
export { AntRadio as Radio, AntRadioGroup as RadioGroup };
